/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';

import { getErrorDetailsFn, getInputFieldProps } from '../../../utils/common';
import { safeString } from '../../../utils/logger';

import useAPIHandler from '../../../hook/use-api-handler';


import { useNavigate } from 'react-router-dom';
import useSnackbar from '../../../hook/use-snakbar';
import fetchDataWithPromise from '../../../utils/fetch-data';
import { OWNERSHIP_API, OWNERSHIP_FORM_FIELDS, OWNERSHIP_INITIAL_STATE } from './ownership-constant';
import { createOwnershipSchema } from './ownership-validation';

const useOrganisationOwnershipService = () => {
const navigate=useNavigate();
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = useState(1);
    const [resource, setResource] = useState(null);

    const {
      snackbarVisible,
      snackbarMessage,
      openSnackbar,
      closeSnackbar,
      snackColor,
    } = useSnackbar();
    const handleClickOpen = (_,data) =>{ 
      setErrors({});


    
      setOrganisationBanking(data? data:structuredClone(OWNERSHIP_INITIAL_STATE))
      setOpen(true);
    };
    const handleClose = () => setOpen(false);
  
    const [organisationBanking, setOrganisationBanking] = useState(
     structuredClone(OWNERSHIP_INITIAL_STATE)
    );
     const { fetchData } = useAPIHandler();
    const [createUpdateLoading, setCreateUpdateLoading] = useState(false);
  
    const [errors, setErrors] = useState({});


  
    const handleChangeFunction = (e, name) => {
     
        let value = e;
    
        if (e && e.target) {
          value = e.target.value;
        }
    
        if (
          OWNERSHIP_FORM_FIELDS[name].customOptions &&
          OWNERSHIP_FORM_FIELDS[name].customOptions?.formatValueFn
        ) {
          value = OWNERSHIP_FORM_FIELDS[name].customOptions?.formatValueFn(
            value,
            organisationBanking
          );
        }
    
        setOrganisationBanking((prevUser) => ({
          ...prevUser,
          [name]: value,
        }));
    
        const fieldSchema = createOwnershipSchema.extract(name);
        const { error } = fieldSchema.validate(value, {
          //   context: { allowanceType: allowance.allowanceType },
        });
    
      
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
    };

    

  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = createOwnershipSchema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }


  
    const handleSubmitFn = async () => {
     let payloadInfo={};


      if(!organisationBanking?.id){
        payloadInfo={...OWNERSHIP_API.OWNERSHIP_CREATE}
      }else{
        payloadInfo={
          url:OWNERSHIP_API.OWNERSHIP_UPDATE.url+organisationBanking?.id,
          method:OWNERSHIP_API.OWNERSHIP_UPDATE.method,
        }

      }
    

      const {
           name,
    phone,
    email,
    designation,
    pan,
    identity_no
       }=organisationBanking;
   
      const { error } = createOwnershipSchema.validate({
           name,
    phone,
    email,
    designation,
    pan,
    identity_no
      }, {
        abortEarly: false,
      });
      


  
      if ( error && error?.details?.length > 0) {
          const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
      }
       else {
        const payload={
        ...payloadInfo,
          data: {
            name,
    phone,
    email,
    designation,
    pan,
    identity_no
          }
          }
       
        setCreateUpdateLoading(true);
        try {
          await fetchData(payload);
          openSnackbar({
            message:organisationBanking?.id ? "Owership Updated succesfully!":"Owership Created succesfully!",
  color: "success",
});
          handleClose();
          const promiseData = fetchDataWithPromise(
             OWNERSHIP_API.OWNERSHIP_LIST.url
           );
       
           setResource(promiseData);
      
       
        } catch (error) {


      const {

        type,
        message,
        details,
        errorObj
      }=    getErrorDetailsFn(error)
      
          openSnackbar({
                      message,
            color: "danger",
          });
setErrors(errorObj)
          setCreateUpdateLoading(false);
        } finally {
          setCreateUpdateLoading(false);
        }
      }
    };
  

function handleResetForm(data) { 
  setOrganisationBanking({...structuredClone(OWNERSHIP_INITIAL_STATE),...data})
}
  

    const getInputFieldPropsFn = (fieldName = "") => {
      // eslint-disable-next-line no-unused-vars
      const { customOptions = {}, ...restProps } =
        OWNERSHIP_FORM_FIELDS[fieldName] || {};
  
    
  
    
    
      const error = safeString(errors[fieldName]);
      const props = {
        ...restProps,
        ...getInputFieldProps({
          name: fieldName,
          stateValues: organisationBanking,
          type: restProps.type||"text",
          error,
          handleChangeFunction,
          handleBlurFn
        }),
      };
  
    
      return props;
    };
 
  
  
    useEffect(() => {
      // Use cachedApiCall to fetch data and wrap it
      const promiseData = fetchDataWithPromise(
     OWNERSHIP_API.OWNERSHIP_LIST.url
      );
      fetchData(
   {url:  OWNERSHIP_API.OWNERSHIP_LIST.url}
      ).then(res=>{
   
        // if(res?.data?.ownerships?.length > 0
        //   ){

        //     navigate('/organization-details/ownership-info')
        //   }
      })
  
      setResource(promiseData);
    }, []);

  
 
    
  return {
    handleSubmitFn,
    getInputFieldPropsFn,
    organisationBanking,
    createUpdateLoading,
    handleClickOpen,
    handleClose,
    open,
    setOpen,
    handleResetForm,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    resource,}
}

export default useOrganisationOwnershipService